/**
 * @generated SignedSource<<bf5d4f87ce20c68db647f1b1265900a8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespCondensedListedContent_viewer$data = {
  readonly showHeartCount: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSharedHeroCarousel_viewer" | "PdpSharedPromoCode_viewer" | "PdpSharedShippingBadge_viewer">;
  readonly " $fragmentType": "PdpRespCondensedListedContent_viewer";
};
export type PdpRespCondensedListedContent_viewer$key = {
  readonly " $data"?: PdpRespCondensedListedContent_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespCondensedListedContent_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespCondensedListedContent_viewer",
  "selections": [
    {
      "alias": "showHeartCount",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "pdpDisplayHeartCount"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"pdpDisplayHeartCount\")"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedShippingBadge_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedPromoCode_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSharedHeroCarousel_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "b2fea0afac11c96641be61a2dbb7002d";

export default node;
